import { nsAccount } from '@/app/i18n/namespaces';

const MERCHANT_ACCOUNT_STATUS = {
    ACTIVE: { name: 'ACTIVE', entity: 'status.ACTIVE', namespace: nsAccount, variant: 'green' },
    INACTIVE: { name: 'INACTIVE', entity: 'status.INACTIVE', namespace: nsAccount, variant: 'red' }
};

export default MERCHANT_ACCOUNT_STATUS;